import { Grid, Section } from '@gogame/components';
import { FormFieldGroup, withArrayFormField } from '@gogame/form';

import { ConversionPageField } from 'scenes/Campaigns/components/Form/fields';
import {
  loadIOSLandingPages,
  loadAndroidLandingPages,
} from 'scenes/Campaigns/sources/fields';

import {
  CAMPAIGNS,
  ANDROID_CONVERSION_PAGE_FIELD,
  IOS_CONVERSION_PAGE_FIELD,
  PLATFORM,
} from '../constants';

const IOS = 2;
const ANDROID = 3;

const MultiConversionPageFields = withArrayFormField()(({
  value,
  name,
  fields,
  disabled,
}) => {
  return (
    <Grid container spacing={2}>
      {value?.map((campaign, i) => {
        let configFieldName;
        let label;
        let loader;

        switch (campaign.platformId) {
          case ANDROID:
            configFieldName = ANDROID_CONVERSION_PAGE_FIELD;
            label = 'Android Conversion page';
            loader = loadAndroidLandingPages;
            break;
          case IOS:
            configFieldName = IOS_CONVERSION_PAGE_FIELD;
            label = 'IOS Conversion page';
            loader = loadIOSLandingPages;
            break;
          default:
            configFieldName = '';
        }

        const isFieldVisible = fields[configFieldName];

        return (
          isFieldVisible && (
            <Grid item xs={6} key={i}>
              <FormFieldGroup name={`${name}[${i}]`}>
                <ConversionPageField
                  label={label}
                  source={loader}
                  dependencies={[`${name}[${i}].${PLATFORM}`]}
                  disabled={disabled}
                />
              </FormFieldGroup>
            </Grid>
          )
        );
      })}
    </Grid>
  );
});

export const ConversionPageSection = ({ fields, disabled }) => {
  return (
    <Section title={'Conversion Page'}>
      <Grid container spacing={3}>
        <Grid item container xs={12}>
          <MultiConversionPageFields
            name={CAMPAIGNS}
            fields={fields}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </Section>
  );
};

export const SingleConversionPageSection = ({ fields, disabled }) => {
  return (
    <Section title={'Conversion Page'}>
      <Grid container item xs={12} spacing={3}>
        {[ANDROID_CONVERSION_PAGE_FIELD, IOS_CONVERSION_PAGE_FIELD].map(
          (parameter) => {
            const isFieldVisible = fields[parameter];

            const loader =
              parameter === ANDROID_CONVERSION_PAGE_FIELD
                ? loadAndroidLandingPages
                : loadIOSLandingPages;
            const label =
              parameter === ANDROID_CONVERSION_PAGE_FIELD ? 'Android' : 'IOS';

            return (
              isFieldVisible && (
                <Grid item xs={6}>
                  <ConversionPageField
                    source={loader}
                    label={label}
                    dependencies={[PLATFORM]}
                    disabled={disabled}
                  />
                </Grid>
              )
            );
          }
        )}
      </Grid>
    </Section>
  );
};
